import { getLogger, configure } from 'log4js'
import dayjs from 'dayjs'

configure({
  appenders: {
    console: {
      type: 'console', // 会打印到控制台
    },
    requestLog: {
      filename: `logs/application/${dayjs().format('YYYY-MM-DD')}/resquest.log`,
      type: 'dateFile',
      alwaysIncludePattern: true,
      layout: {
        type: 'pattern',
        pattern: `[${dayjs().format('YYYY-MM-DD HH:mm:ss')}]:'%m`,
      },
      pattern: 'yyyy-MM-dd',
      daysToKeep: 10,
      numBackups: 3,
      keepFileExt: true,
    },
    responseLog: {
      filename: `logs/application/${dayjs().format('YYYY-MM-DD')}/response.log`,
      type: 'dateFile',
      alwaysIncludePattern: true,
      layout: {
        type: 'pattern',
        pattern: `[${dayjs().format('YYYY-MM-DD HH:mm:ss')}]:'%m`,
      },
      pattern: 'yyyy-MM-dd',
      daysToKeep: 10,
      numBackups: 3,
      keepFileExt: true,
    },
    errorLog: {
      filename: `logs/application/${dayjs().format('YYYY-MM-DD')}/error.log`,
      type: 'dateFile',
      alwaysIncludePattern: true,
      layout: {
        type: 'pattern',
        pattern: `[${dayjs().format('YYYY-MM-DD HH:mm:ss')}]:'%m`,
      },
      pattern: 'yyyy-MM-dd',
      daysToKeep: 10,
      numBackups: 3,
      keepFileExt: true,
    },
  },
  categories: {
    default: {
      appenders: ['console'],
      level: 'info',
    },
    resquestLogger: {
      appenders: ['console', 'requestLog'],
      level: 'info',
    },
    responseLogger: {
      appenders: ['console', 'responseLog'],
      level: 'info',
    },
    errorLogger: {
      appenders: ['console', 'errorLog'],
      level: 'error',
    },
  },
})

// 请求日志
export const requestLog = getLogger('requestLog')
// 数据返回日志
export const responseLog = getLogger('responseLog')
// 报错日志
export const errorLog = getLogger('errorLog')
